import React from 'react';
import { Switch } from 'react-router-dom';

import RouteHandler from './components/RouteHandler';

import Home from './pages/Home';
import Historia from './pages/Historia';
import Produtos from './pages/Produtos';
import Contato from './pages/Contato';

export default () => {
    return(
        <Switch>
            <RouteHandler exact path='/'>
                <Home />
            </RouteHandler>
            <RouteHandler exact path='/historia'>
                <Historia />
            </RouteHandler>
            <RouteHandler exact path='/Produtos'>
                <Produtos />
            </RouteHandler>
            <RouteHandler exact path='/Contato'>
                <Contato />
            </RouteHandler>
            <RouteHandler>
                <Home />
            </RouteHandler>
        </Switch>
    )
}